import React, {PropTypes} from 'react';
import _ from 'lodash';

// components
import TextArea from '../../../../../common/components/c_TextArea';

export default class BehavioralInterview extends React.Component {
  static propTypes = {
    staticData: PropTypes.object,
    applicant: PropTypes.object,
    behavioralAnswers: PropTypes.object,
    script: PropTypes.bool,
    tempState: PropTypes.object,
    model: PropTypes.string.isRequired,
    dispatch: PropTypes.func,
    saveData: PropTypes.func,
  };

  constructor() {
    super();
    this.state = { values: {} };
  }

  onChange(questionId, event) {
    const values = _.assign({}, this.state.values, { [questionId]: event.target.value });
    this.setState({ values });
  }

  onBlur(questionId, event) {
    if (event.target.value !== _.get(this.props.behavioralAnswers[questionId], 'answer')) {
      this.props.saveData({ behavioralAnswers:  _.set({}, `${questionId}.answer`, event.target.value) });
    }
  }

  getValue(questionId) {
    const newLine = /\\n/g;
    let value = '';
    if (this.state.values.hasOwnProperty(questionId)) {
      value = this.state.values[questionId];
    }
    else if (this.props.behavioralAnswers[questionId]) {
      value = _.get(this.props.behavioralAnswers[questionId], 'answer');
    }
    return value.replace(newLine, '\n');
  }

  render() {
    // booleans
    const script = this.props.script;
    const behavioralQuestions = this.props.staticData.behavioralQuestions;

    return (
      <div className='expanded-accordion-content explanation-of-wahve'
        key={`behavioral-interview ${this.props.applicant.profile.id}`}>
        {
          script
          &&
          <div>
            <div className='speaking-callout'>
              I would now like to ask you some questions that will help us get to know you better. The questions only
              relate to your work experience and not personal.
            </div>
          </div>
        }
        <div data-id='Questions' className='behavioral-questions'>
          <div className='title'><b>Questions:</b></div>
          <ul className='instructions-list' style={{ paddingBottom: !this.props.script ? '15px' : null }}>
            {
              behavioralQuestions.map((listItem, questionKey) =>
                <li
                  className='instructions-list-item'
                  key={questionKey}
                >
                  <div className='instructions-list-text'>
                    {listItem.question}
                  </div>
                  <TextArea data-id={listItem.id}
                            maxLength={4000}
                            className='instructions-text-field'
                            value={ this.getValue(listItem.id) }
                            onBlur={ this.onBlur.bind(this, listItem.id) }
                            onChange={ this.onChange.bind(this, listItem.id) }
                            validator={ this.props.validator.bind(this, listItem) }
                            onErrorChange={ this.props.errorUpdate }
                            showCharacterCount
                  />
                </li>
              )
            }
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Interview/f_BehavioralInterview/index.js